export const Items = [
    {
        title : "Home",
        url : "/",
        cName : "nav-links",
        icon : "fa-regular fa-house"
    },
    {
        title : "About",
        url : "/about",
        cName : "nav-links",
        icon : "fa-solid fa-circle-info"
    },
    {
        title : "Schedule",
        url : "/Schedule",
        cName : "nav-links",
        icon : "fa-solid fa-briefcase"
    },
    {
        title : "Contact",
        url : "/contact",
        cName : "nav-links",
        icon : "fa-solid fa-address-book"
    },
    {
        title : "SignUp",
        url : "/signup",
        cName : "nav-links-mobile",
    }
]